import { Link, useLocation } from 'react-router';
import { useAuth } from '../context/AuthContext';
import {
  SIMULATOR_NAV_ITEM,
  STATS_NAV_ITEM,
  TRAINER_NAV_ITEM,
} from '../constants/navigation';
import './Footer.css';

function Footer() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const isSitePage = pathname === '/' || pathname === '/about' || pathname === '/newsletter' ||
                     pathname === '/privacy-policy' || pathname === '/terms-of-service' ||
                     pathname === '/cookie-policy' || pathname === '/data-deletion';
  const statsTo = isAuthenticated ? STATS_NAV_ITEM.to : '/signup';

  return (
    <footer className={`footer${isSitePage ? ' footer--landing' : ''}`} role="contentinfo">
      <div className="footer-content">
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to={TRAINER_NAV_ITEM.to} className="footer-link">{TRAINER_NAV_ITEM.label}</Link>
          <Link to={SIMULATOR_NAV_ITEM.to} className="footer-link">{SIMULATOR_NAV_ITEM.label}</Link>
          {isAuthenticated ? (
            <Link to={statsTo} className="footer-link">{STATS_NAV_ITEM.label}</Link>
          ) : (
            <a href={statsTo} className="footer-link">{STATS_NAV_ITEM.label}</a>
          )}
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/newsletter" className="footer-link">Newsletter</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
          <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
          <Link to="/data-deletion" className="footer-link">Data Deletion</Link>
        </nav>
        <div className="footer-copyright" role="contentinfo">
          <small>&copy; {new Date().getFullYear()} Tekra, LLC</small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
